var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "filter-control-template",
    {
      staticClass: "filter-col-md",
      attrs: {
        field: _vm.field,
        placeholder: _vm.placeholder,
        type: "string",
        predicate: _vm.predicate,
        pillFormatter: _vm.pillFormatter,
        labelFormatter: _vm.labelFormatter,
        options: _vm.selectionOptions,
        color: _vm.color,
        label: _vm.label,
        multiple: !!_vm.multiple,
        inclusive: !!_vm.inclusive || !!_vm.multiple,
        disabled: _vm.disabled,
        computedField: _vm.computedField,
        fillFirstItem: _vm.fillFirstItem,
      },
      on: {
        "input-change": function ($event) {
          return _vm.$emit("input-change", $event)
        },
      },
    },
    [_vm._t("default")],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }